import { useTranslation } from 'react-i18next';

import { ToggleGroup, ToggleGroupItem } from '@nucleus-commerce/ui/components/toggle-group';

import { useDayFormat } from '../hooks/use-day-format';
import {
  ANALYTICS_RANGES,
  isAnalyticsRange,
  type AnalyticsRange,
  type AnalyticsRangeDays,
} from '../schemas/analytics-range';

export interface AnalyticsRangePickerProps {
  range: AnalyticsRange;
  onChange: (days: AnalyticsRangeDays) => void;
}

/** 7 / 28 / 90 complete days; the dates the choice covers sit beside it. */
export function AnalyticsRangePicker({ range, onChange }: AnalyticsRangePickerProps) {
  const { t } = useTranslation('social');
  const days = useDayFormat();

  return (
    <div className="flex flex-wrap items-center gap-3">
      <ToggleGroup
        type="single"
        variant="outline"
        size="sm"
        value={String(range.days)}
        onValueChange={(value) => {
          const next = Number(value);
          if (isAnalyticsRange(next)) onChange(next);
        }}
        aria-label={t('analytics.range.label')}
      >
        {ANALYTICS_RANGES.map((option) => (
          <ToggleGroupItem key={option} value={String(option)} className="px-3">
            {t('analytics.range.days', { count: option })}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
      <span className="text-muted-foreground text-sm" data-testid="social-range-label">
        {days.range(range.from, range.to)}
      </span>
    </div>
  );
}
